import { SafeMap } from 'app/tools/utils';

export const DefectTypes = {
  'manufacturing-defect': 'Defect in workmanship or materials',
  'accidental-damage': 'Accidental damage',
  'water-damage': 'Water damage',
  'other-issue': 'Other / Not sure',
};

export const DefectTypesMap = new SafeMap(DefectTypes);
